import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { Popover, Pressed } from 'libs/ui';
import { CSSObject, styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const SelectStyled = styled(Pressed)(() => ({
  padding: '0 8px 0 12px',
  height: 32,
  border: `1px solid ${Colors.gray300}`,
  backgroundColor: Colors.white,
  borderRadius: 4,
  alignItems: 'center',
  gap: 4,

  '&:hover': {
    backgroundColor: Colors.gray100,
  },

  '.dateFilter-count': {
    backgroundColor: Colors.blue200,
    borderRadius: 2,
    padding: '0 8px',
    height: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '.dateFilter-count-label': {
      fontSize: 11,
      lineHeight: 1,
      color: Colors.blue600,
    } as CSSObject,
  } as CSSObject,
}));

export const PopoverStyled = styled(Popover)(() => ({
  [Popover.classes.paper]: {
    maxWidth: 320,
  },
}));

export const PopoverContentStyled = styled('div')(({ theme }) => ({
  '.dateFilter-footer': {
    borderTop: `1px solid ${Colors.gray200}`,
    marginTop: 8,

    '.dateFilter-footer-clear': {
      width: '100%',
      padding: '8px 12px',
      ...theme.typography.captionMedium,
      color: Colors.red500,

      '&:hover': {
        backgroundColor: Colors.gray100,
      } as CSSObject,
    },
  } as CSSObject,
}));

export const DateCalendarStyled = styled(DateCalendar)(({ theme }) => ({
  margin: 0,

  '.MuiIconButton-root': {
    padding: 4,
    transition: theme.transitions.create('color'),

    '&:hover': {
      color: Colors.hover,
    },
  },
}));
